import React from "react";
import { Alert } from "./Alert";
import {
  KontentLinks,
  KontentMultiChoice,
  KontentRichText,
  StringValue,
} from "../../../types";
import { formatLinks } from "../../../lib/links";
import { getMultiChoice } from "../../../lib/multichoice";

export type AlertStyles = "dark" | "light" | "transparent" | "red" | "gold";
export type AlertAlignment = "left" | "center";

export interface AlertProps {
  id: string;
  text: KontentRichText;
  publish_date: StringValue;
  unpublish_date: StringValue;
  link_configuration__link: KontentLinks;
  style: KontentMultiChoice<AlertStyles>;
  alignment?: KontentMultiChoice<AlertAlignment>;
}

const AlertContainer: React.FC<AlertProps> = ({
  publish_date,
  unpublish_date,
  link_configuration__link,
  text,
  id,
  style,
  alignment,
}) => {
  const now = new Date();

  const active =
    new Date(parseInt(publish_date?.value)) < now &&
    new Date(parseInt(unpublish_date?.value)) > now;

  if (!active) return null;

  const cta =
    link_configuration__link?.modular_content &&
    formatLinks(link_configuration__link?.modular_content)[0];

  return (
    <Alert
      id={id}
      text={text}
      cta={cta}
      style={getMultiChoice(style)}
      alignment={alignment?.value && getMultiChoice(alignment)}
    ></Alert>
  );
};

export default AlertContainer;
